module.exports = __webpack_public_path__ + "img/progress.b5a362c0.svg";